module.exports = __webpack_public_path__ + "static/img/Sub beam 4,8m (hollow 40x40x4,8m).9da36c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Sub beam 4,8m (hollow 40x40x4,8m).jpg
// module id = 102
// module chunks = 1